/**
 *
 * App time formats.
 * TODO: set correct names for time formats (rename all).
 * constants should be independent of functionality (common names through the app),
 * for example "datetime", "month", "date month", not "timelineTime".
 */

export default {
    datePickerDate: 'YYYY-MM-DD',
    datetime: 'MMM Do, YYYY [at] h:mm a',
    date: 'MMM Do, YYYY',
    shortDate: 'MMM D, YYYY',
    shortDateTime: 'MMM D, YYYY h:mm a',
    shortDate24HrTime: 'MMM D, YYYY HH:mm',
    time: 'HH:mm:ssZ',
    shortTime: 'hh:mm a',
    timeApiFormat: 'HH:mm:ssZ',
    longDate: 'MMMM Do, YYYY',
    longDateTime: 'MMMM Do, YYYY [at] hh:mmA',
    timelineDateTime: 'MMMM Do hh:mm:ss A',
    timelineTime: 'h:mm:ss A',
    timelineHeader: 'MMMM D',
    inlineDateValue: 'MMM Do YYYY',
    orderDatetime: 'MMM Do, YYYY h:mm a',
    orderDate: 'MMM Do',
};
